/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BergerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA9klEQVR4nN1SUY4BQRBtP06DAwgnoPrVfowqDoM/rsByGbLXEB9cwWYTQtqYXZmZTmZpH+Yl9VHprvde12tjSgkibVjWhYVsCfpjWc95dT2DbN1dYFAvwl0hyJggJx+p9YpdZ0aOw+8cMr4fAqTZ5X6raB+XDL1rSTt3w4C0i/a3tR07H71anvvlo86R6onlMyNwC+sh593sSzZ5At//Ddb6f9chb0Vzt78A5EfLOjPlArF+hdq/TQqy/hUITs5x/QlA1qHJiXVlygUKGTTuAk7wsoATEMs+oMDOpGFZp8F+EHSSEYiiqOpEnnkJxbNTx5UReFtcAMf/QxNBzCiNAAAAAElFTkSuQmCC)
 */
export const BergerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2 18a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v1a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-1ZM1 13a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M8.67 2A6.67 6.67 0 0 0 2 8.67C2 9.4 2.6 10 3.33 10h17.34C21.4 10 22 9.4 22 8.67A6.67 6.67 0 0 0 15.33 2H8.67ZM14 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-1-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM7 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm11 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
